import React from 'react';
import { upperFirst } from 'lodash';
import { cut, firstNameAndLastInitial } from '../utils';

/* eslint-disable react/prop-types */
const AppointmentInfo = (props) => {
  const appointments = props.appointments || [props];

  const shouldShowInfo = (appointments.length && appointments[0].confirmationCode) || props.waitingList;
  if (!shouldShowInfo) {
    return <div className={`c-flagship-appointment-info ${props.className || ''}`} />;
  }

  return (
    <div className={`c-flagship-appointment-info ${props.className || ''}`}>
      <h3 className="u-text-large u-fw-bold u-mb-6">Appointment details</h3>
      {appointments.map((appt, idx) => (
        <div key={appt.confirmationCode || idx}>
          {appointments.length > 1 && idx > 0 && <div className="c-divider u-mt-5 u-mb-5" />}
          {appt.shopLocation && (
            <div className="flgshp-row">
              <span className="flgshp-label">Location</span>
              <span className="flgshp-value">{cut(appt.shopLocation, 20)}</span>
            </div>
          )}
          {appt.confirmationCode && (
            <div className="flgshp-row">
              <span className="flgshp-label">Confirmation code</span>
              <span className="flgshp-value">{appt.confirmationCode}</span>
            </div>
          )}
          {appt.position && (
            <div className="flgshp-row">
              <span className="flgshp-label">Waiting list position</span>
              <span className="flgshp-value">{appt.position}</span>
            </div>
          )}
          {appt.customerName && (
            <div className="flgshp-row">
              <span className="flgshp-label">Client</span>
              <span className="flgshp-value">{firstNameAndLastInitial(appt.customerName)}</span>
            </div>
          )}
          {appt.barberName && (
            <div className="flgshp-row">
              <span className="flgshp-label">Professional</span>
              <span className="flgshp-value">{appt.barberName}</span>
            </div>
          )}
          <div className="flgshp-row">
            <span className="flgshp-label">Service</span>
            <span className="flgshp-value">{upperFirst(cut(appt.service, 20))}</span>
          </div>
          {appt.date && (
            <div className="flgshp-row">
              <span className="flgshp-label">Time</span>
              <span className="flgshp-value">{appt.date}</span>
            </div>
          )}
          <div className="flgshp-row">
            <span className="flgshp-label">Duration</span>
            <span className="flgshp-value">{appt.duration}</span>
          </div>
          {appt.appointmentNote && (
            <div className="u-mt-3 flgshp-row">
              <span className="flgshp-label">Note</span>
              <span className="flgshp-value u-1/2">{cut(appt.appointmentNote, 60)}</span>
            </div>
          )}
        </div>
      ))}
      {props.children}
    </div>
  );
};

export default AppointmentInfo;



// WEBPACK FOOTER //
// ./src/app/notifications/shared/FlagshipAppointmentInfo.jsx